module.exports = __webpack_public_path__ + "media/images/lb/959-43c264b1c0368b18bdaa3be869722bf9.svg";